import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/app/ui/assets/images/bg-feedback-rating.png'
import _imports_1 from '@/app/ui/assets/svg/chevron-left-white.svg'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-full h-20 rounded-lg",
  alt: "bg-feedback"
}, null, -1)
const _hoisted_2 = { class: "absolute font-montserrat px-1 justify-between flex flex-row" }
const _hoisted_3 = { class: "w-36 pl-3 pt-2" }
const _hoisted_4 = { class: "text-10px font-semibold" }
const _hoisted_5 = { class: "text-8px" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("div", { class: "flex items-center justify-center mt-2 relative" }, [
    /*#__PURE__*/_createVNode("div", { class: `w-10 h-10 bg-white rounded-full shadow` }),
    /*#__PURE__*/_createVNode("div", {
      class: "absolute bg-yellow-lp-300 rounded-full",
      style: {"height":"1.75rem","width":"1.75rem"}
    }, [
      /*#__PURE__*/_createVNode("img", {
        src: _imports_1,
        class: "w-3 mt-2 ml-2",
        alt: "left",
        style: {"transform":"rotate(180deg)"}
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "border-2 border-white mx-2 rounded-lg justify-start items-center gap-4 inline-flex relative cursor-pointer",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickBanner && _ctx.onClickBanner(...args)))
  }, [
    _hoisted_1,
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("feedback.title")), 1),
        _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("feedback.subtitle")), 1)
      ]),
      _hoisted_6
    ])
  ]))
}